<div class="container-fluid">
  <div class="row auth-main">
    <div class="col-sm-6 px-0 d-none d-sm-block">
      <div >
        <img src="assets/images/bg-04.png" class="fofimg">
      </div>
    </div>
    <div class="col-sm-6 auth-form-section">
        <div class="datasec">
          <form>
            <span class="fof"> 404 </span>
            <pre>
            </pre>
            <p class="llyl">  Looks Like You're Lost </p>
            <p class="pnav" > The Page You Are Looking For Not Available!</p>
            <pre>
            </pre>
            <div>
              <button mat-flat-button color="primary" routerLink="/admin/dashboard/main" class="gthp" type="submit">
                Go To Home Page
              </button>
            </div>
              <div class="mt-3">
                <a routerLink="/authentication/signin" class="txt1">
                  Need Help?
                </a>
              </div>
          </form>
        </div>
    </div>
  </div>
